import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/search.svg'


const _withScopeId = n => (_pushScopeId("data-v-641e94a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "absolute w-full h-20 bg-slate-200 z-10 opacity-70"
}
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex items-center justify-between h-20" }
const _hoisted_4 = {
  style: {},
  class: "absolute -top-[1px] pt-4 md:pt-0 bg-white left-0 h-14 w-16 md:h-28 md:w-40 text-center md:border border-gray-300 border-t-0 border-radius-5 md:shadow"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "ml-4 flex items-center md:ml-6" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "ml-10 flex items-baseline space-x-4" }
const _hoisted_10 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_11 = { class: "flex items-center hidden lg:flex" }
const _hoisted_12 = { class: "border-l border-dashed border-gray-300 px-2" }
const _hoisted_13 = { class: "border-l border-dashed border-gray-300 px-2" }
const _hoisted_14 = { class: "border-l border-r border-dashed border-gray-300 px-2" }
const _hoisted_15 = { class: "lg:min-w-[120px] border-l border-dashed border-gray-300 md:px-2" }
const _hoisted_16 = { class: "text-sm lg:text-lg" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-xs whitespace-nowrap opacity-75" }, [
  /*#__PURE__*/_createTextVNode("Cash "),
  /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:inline" }, "on Hand")
], -1))
const _hoisted_18 = { class: "lg:min-w-[120px] border-l border-dashed border-gray-300 md:px-2" }
const _hoisted_19 = { class: "text-sm lg:text-lg" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-thin" }, " - ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-xs whitespace-nowrap opacity-75" }, [
  /*#__PURE__*/_createTextVNode("Pending "),
  /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:inline" }, "Trades")
], -1))
const _hoisted_22 = { class: "lg:min-w-[120px] border-l border-r border-dashed border-gray-300 md:px-2" }
const _hoisted_23 = { class: "text-sm lg:text-lg" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-xs whitespace-nowrap opacity-75" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:inline" }, "Rounds"),
  /*#__PURE__*/_createTextVNode(" Owned")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open menu", -1))
const _hoisted_26 = { class: "p-1 hidden" }
const _hoisted_27 = {
  key: 0,
  type: "search",
  class: ""
}
const _hoisted_28 = {
  key: 1,
  class: "animate-menu lg:hidden h-full w-9/12 max-w-md bg-slate-100 absolute right-0 z-20 shadow shadow-l border-l border-slate-500"
}
const _hoisted_29 = { class: "border-b border-dashed border-gray-300 px-2 py-4" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-xl px-4 py-2 font-bold mt-4" }, "Markets", -1))
const _hoisted_31 = { class: "border-b border-t border-dashed border-gray-300 px-2 py-4" }
const _hoisted_32 = { class: "border-b border-dashed border-r border-gray-300 px-2 py-4" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-xl px-4 py-4 font-bold mt-4" }, "Account", -1))
const _hoisted_34 = { class: "border-b border-t border-dashed border-gray-300 px-2 py-4" }
const _hoisted_35 = { class: "border-b border-dashed border-r border-gray-300 px-2 py-4" }
const _hoisted_36 = { class: "border-b border-dashed border-r border-gray-300 px-2 py-4" }
const _hoisted_37 = { class: "border-b border-dashed border-r border-gray-300 px-2 py-4" }
const _hoisted_38 = { class: "border-b border-dashed border-r border-gray-300 px-2 py-4" }
const _hoisted_39 = { class: "border-b border-dashed border-r border-gray-300 px-2 py-4" }
const _hoisted_40 = { class: "border-dashed border-r border-gray-300 px-2 py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MarketsDropdown = _resolveComponent("MarketsDropdown")!
  const _component_ManageAccount = _resolveComponent("ManageAccount")!
  const _component_Bars3Icon = _resolveComponent("Bars3Icon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_Disclosure = _resolveComponent("Disclosure")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["border-b", { approved: _ctx.isApproved }])
  }, [
    (_ctx.disabledNav)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_component_Disclosure, {
      as: "header",
      class: "bg-white shadow"
    }, {
      default: _withCtx(({ open }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "relative h-20 w-40"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    class: "h-12 w-14 md:h-28 md:w-32 inline",
                    src: `/${_ctx.appId}/logo-full.svg`,
                    alt: "Ammo Exchange"
                  }, null, 8, _hoisted_5)
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (!_ctx.searchIsOpen)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_router_link, {
                                to: "/",
                                class: _normalizeClass([_ctx.router.currentRoute.value.name == 'Index' ? 'text-blue-700' : '',' hover:text-blue-700 rounded text-gray-800 px-3 py-6 text-sm font-medium'])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Dashboard")
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_router_link, {
                                to: "/commodities",
                                class: _normalizeClass([_ctx.router.currentRoute.value.name == 'Commodities' ? 'text-blue-700' : '',' hover:text-blue-700 rounded text-gray-800 px-3 py-6 text-sm font-medium'])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Commodities")
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_router_link, {
                                to: "/products",
                                class: _normalizeClass([_ctx.router.currentRoute.value.name == 'Products' ? 'text-blue-700' : '',' hover:text-blue-700 rounded text-gray-800 px-3 py-6 text-sm font-medium'])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Products")
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ])
                          ]),
                          _createVNode(_component_MarketsDropdown, { class: "hidden sm:block lg:hidden" }),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_router_link, {
                              to: "/account/cash-balance",
                              class: _normalizeClass([_ctx.router.currentRoute.value.name == 'AccountCashManagement' ? 'text-blue-700' : '','block h-full hover:bg-gray-200 hover:text-blue-700 rounded text-gray-800 px-3 py-2 text-sm font-medium text-center'])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.currencySymbol) + _toDisplayString(_ctx.cashAvailable), 1),
                                _hoisted_17
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_router_link, {
                              to: "/account/pending-trades",
                              class: _normalizeClass([_ctx.router.currentRoute.value.name == 'AccountPendingTrades' ? 'text-blue-700' : '','block h-full hover:bg-gray-200 hover:text-blue-700 rounded text-gray-800 px-3 py-2 text-sm font-medium text-center'])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_19, [
                                  _createTextVNode(_toDisplayString(_ctx.pendingRoundsToBuy), 1),
                                  _hoisted_20,
                                  _createTextVNode(_toDisplayString(_ctx.pendingRoundsToSell), 1)
                                ]),
                                _hoisted_21
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_router_link, {
                              to: "/account/asset-management",
                              class: _normalizeClass([_ctx.router.currentRoute.value.name == 'AccountAssetManagement' ? 'text-blue-700' : '','block h-full hover:bg-gray-200 hover:text-blue-700 rounded text-gray-800 px-3 py-2 text-sm font-medium text-center'])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.roundsOwned), 1),
                                _hoisted_24
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _createVNode(_component_ManageAccount),
                          _createVNode(_component_DisclosureButton, {
                            onClick: _ctx.toggleMenu,
                            class: "lg:hidden rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_25,
                              (!_ctx.menuOpen)
                                ? (_openBlock(), _createBlock(_component_Bars3Icon, {
                                    key: 0,
                                    class: "block h-6 w-6",
                                    "aria-hidden": "true"
                                  }))
                                : (_openBlock(), _createBlock(_component_XMarkIcon, {
                                    key: 1,
                                    class: "block h-6 w-6",
                                    "aria-hidden": "true"
                                  }))
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("img", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args))),
                        class: "inline-block cursor-pointer h-6 w-6",
                        src: _imports_0
                      }),
                      (_ctx.searchIsOpen)
                        ? (_openBlock(), _createElementBlock("input", _hoisted_27))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.menuOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_router_link, {
              to: "/",
              class: _normalizeClass([_ctx.router.currentRoute.value.name == 'Index' ? 'text-blue-700' : '',' hover:text-blue-700 rounded text-gray-800 px-3 py-6  text-sm font-medium'])
            }, {
              default: _withCtx(() => [
                _createTextVNode("Dashboard")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_router_link, {
              to: "/commodities",
              class: _normalizeClass([_ctx.router.currentRoute.value.name == 'Commodities' ? 'text-blue-700' : '',' hover:text-blue-700 rounded text-gray-800 px-3 py-6  text-sm font-medium'])
            }, {
              default: _withCtx(() => [
                _createTextVNode("Commodities")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_router_link, {
              to: "/products",
              class: _normalizeClass([_ctx.router.currentRoute.value.name == 'Products' ? 'text-blue-700' : '',' hover:text-blue-700 rounded text-gray-800 px-3 py-6  text-sm font-medium'])
            }, {
              default: _withCtx(() => [
                _createTextVNode("Products")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_router_link, {
              to: "/account",
              class: _normalizeClass([_ctx.router.currentRoute.value.name == 'AccountOverview' ? 'text-blue-700' : '',' hover:text-blue-700 rounded text-gray-800 px-3 py-6  text-sm font-medium'])
            }, {
              default: _withCtx(() => [
                _createTextVNode("Overview")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_router_link, {
              to: "/account/cash-balance",
              class: _normalizeClass([_ctx.router.currentRoute.value.name == 'AccountCashBalance' ? 'text-blue-700' : '',' hover:text-blue-700 rounded text-gray-800 px-3 py-6  text-sm font-medium'])
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cash Balance")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_router_link, {
              to: "/account/pending-trades",
              class: _normalizeClass([_ctx.router.currentRoute.value.name == 'AccountPendingTrades' ? 'text-blue-700' : '',' hover:text-blue-700 rounded text-gray-800 px-3 py-6  text-sm font-medium'])
            }, {
              default: _withCtx(() => [
                _createTextVNode("Pending Trades")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_router_link, {
              to: "/account/asset-management",
              class: _normalizeClass([_ctx.router.currentRoute.value.name == 'AccountAssetManagement' ? 'text-blue-700' : '',' hover:text-blue-700 rounded text-gray-800 px-3 py-6  text-sm font-medium'])
            }, {
              default: _withCtx(() => [
                _createTextVNode("Asset Management")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_router_link, {
              to: "/account/completed-trades",
              class: _normalizeClass([_ctx.router.currentRoute.value.name == 'AccountCompletedTrades' ? 'text-blue-700' : '',' hover:text-blue-700 rounded text-gray-800 px-3 py-6  text-sm font-medium'])
            }, {
              default: _withCtx(() => [
                _createTextVNode("Order History")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_router_link, {
              to: "/account/profile-settings",
              class: _normalizeClass([_ctx.router.currentRoute.value.name == 'ProfileSettings' ? 'text-blue-700' : '',' hover:text-blue-700 rounded text-gray-800 px-3 py-6  text-sm font-medium'])
            }, {
              default: _withCtx(() => [
                _createTextVNode("Profile Settings")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("h1", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logoutMobile && _ctx.logoutMobile(...args))),
              class: "hover:text-blue-700 text-red-600 px-3 text-sm font-medium"
            }, "Logout")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.menuOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
          class: "lg:hidden h-full w-full bg-slate-800 absolute opacity-30 z-10"
        }))
      : _createCommentVNode("", true)
  ], 2))
}